<template>
  <div>
    <!-- Engineering controls -->
    <b-row
      class="d-flex justify-content-between align-items-center bg-light py-3"
    >
      <b-col md="3">
        <b-form-checkbox
          switch
          size="sm"
          v-model="proposal.steps.engineering.actived"
          >Engenharia</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.engineering.situation"
          :options="engineeringSituationOptions"
          v-if="proposal.steps.engineering.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.engineering.status"
          v-if="engineeringStatusOptions[proposal.steps.engineering.situation]"
          :options="
            engineeringStatusOptions[proposal.steps.engineering.situation]
          "
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.engineering.dueDate"
          v-if="proposal.steps.engineering.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-form-group class="mb-0">
          <div class="mb-4"><b>Dados da Matrícula</b></div>

          <b-row>
            <b-col
              ><small class="form-text text-muted mb-1">Nº da Matrícula</small>
              <b-form-input
                size="sm"
                v-model="proposal.matricula"
                placeholder="Digite o nº da Matrícula"
              ></b-form-input
            ></b-col>
            <b-col
              ><small class="form-text text-muted mb-1"
                >Data da Matrícula</small
              >
              <b-form-datepicker
                class="mb-2"
                size="sm"
                placeholder="Data de emissão"
                locale="pt-BR"
                today-button
                reset-button
                close-button
                :date-format-options="{
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                }"
                v-model="proposal.issueDate"
              ></b-form-datepicker
            ></b-col>
          </b-row>
        </b-form-group>

        <small class="form-text text-muted mb-1">Localização do Imóvel</small>
        <!-- <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.propertyLocation"
                  ></b-form-input> -->
        <vue-google-autocomplete
          ref="address"
          id="map"
          classname="form-control form-control-sm"
          placeholder="Localização do Imóvel"
          country="br"
          v-on:placechanged="getAddressData"
          v-model="locationData"
          types=""
          size="sm"
        >
        </vue-google-autocomplete>
        <small class="form-text text-muted mt-3 mb-1"
          >Imóvel possui Interveniente Quitante?</small
        >

        <b-form-checkbox switch size="sm" v-model="proposal.propertyIQ"
          >Sim</b-form-checkbox
        >
        <div v-if="proposal.propertyIQ">
          <small class="form-text text-muted mt-3 mb-1"
            >De qual instituição bancária?</small
          >
          <b-form-select
            v-model="bankingnDischargerIntervener"
            :options="bankingnDischargerIntervenerOptions"
            :select-size="4"
          ></b-form-select>
          <small class="form-text text-muted mt-1 mb-1"
            >Should show info text...</small
          >
        </div>

        <small class="form-text text-muted mt-3 mb-1"
          >Valor de Avaliação da Engenharia</small
        >
        <currency-input
          ref="engineeringEvaluation"
          class="mb-2 form-control form-control-sm"
          maxlength="9"
          v-model="proposal.engineeringEvaluation"
          currency="BRL"
          locale="pt"
        />
      </b-col>
      <b-col style="border-left: 1px solid #ccc">
        <div class="mb-4"><b>Verificações necessária</b></div>
        <div v-for="(list, index) in pendingList" :key="index">
          <div
            class="
              userListItem
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div class="userListItemLabel">{{ list.item }}</div>
            <b-form-checkbox v-model="list.show"></b-form-checkbox>
          </div>
        </div>
        <div class="mt-5">
          <b-form-text
            v-if="proposal.propertyIQ"
            class="mt-0 d-flex align-items-center"
          >
            <b-form-checkbox v-model="proposal.verifiedSD"></b-form-checkbox>
            <i :class="!proposal.verifiedSD ? 'text-danger' : 'text-success'">
              Verificar SD do contrato anterior.
              {{ bankingnDischargerIntervener }}
            </i>
            <i
              class="fa fa-info-circle text-info ml-2"
              v-b-tooltip.hover.top
              title="Solicitar a tela PDL ao gerente para verificação se o SD está ativo, sem impecílhos e se o mesmo é menor ou igual ao valor de financiamento."
            ></i>
          </b-form-text>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { CurrencyInput } from "vue-currency-input";
import VueGoogleAutocomplete from "vue-google-autocomplete";

var moment = require("moment");
moment.locale("pt-br");

var bootbox = require("bootbox");

export default {
  name: "ControlOfTheEngineeringFlow",
  data() {
    return {
      array: "",
      engineeringSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Boleto",
          text: "Boleto",
          color: "secondary",
          msg: "Boleto de engenharia enviado para pagamento em",
          progress: 5,
        },
        {
          value: "Convocada",
          text: "Revisão",
          color: "info",
          msg: "O.S. de engenharia convocada em",
          progress: 13,
        },
        {
          value: "Emitida",
          text: "Emitida",
          color: "primary",
          msg: "O.S. de engenharia emitida em",
          progress: 15,
        },
        { value: "Laudo", text: "Laudo", color: "", msg: "", progress: 0 },
      ],
      engineeringStatusOptions: {
        Laudo: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Válido",
            text: "Válido",
            color: "success",
            msg: "Imóvel aceito como garantia em",
            progress: 25,
          },
          {
            value: "Inválido",
            text: "Inválido",
            color: "danger",
            msg: "Imóvel não aceito como garantia em",
            progress: 5,
          },
          {
            value: "Pept",
            text: "Pept",
            color: "warning",
            msg: "Imóvel aguardando cumprimento de exigência em",
            progress: 21,
          },
        ],
      },
      bankingnDischargerIntervener: "",
      bankingnDischargerIntervenerOptions: [
        {
          value: "033 - Banco Bradesco S.A.",
          text: "033 - Banco Bradesco S.A.",
          info:
            "Cliente deverá solicitar o boleto de quitação e procurações junto ao seu gerente.",
        },
        {
          value: "104 - Caixa Econômica Federal",
          text: "104 - Caixa Econômica Federal",
          info: "Solicitar a tela PDL para o gerente",
        },
        {
          value: "341 - Itaú Unibanco S.A.",
          text: "341 - Itaú Unibanco S.A.",
          info: "Enviar e-mail para XXXX solicitando o boleto de quitação.",
        },
      ],
      pendingList: [
        {
          item: "Matrícula é de inteiro teor",
          subItem:
            "Solicitar matrícula de inteiro teor com ônus reais e/ou ações reipercussórias",
          show: false,
        },
        {
          item: "Matrícula é de ônus reais e/ou ações reipercussórias",
          subItem:
            "Solicitar matrícula de inteiro teor com ônus reais e/ou ações reipercussórias",
          show: false,
        },
        {
          item: "Foi localizado o habite-se",
          subItem:
            "Verifique a necessidade de solicitação do habite-se ou declaração da prefeitura local para comprovação de legalização do imóvel",
          show: false,
        },
        {
          item:
            "Verificado se o imóvel foi adquirido há menos de 3 e se foi ou não utilizado FGTS na aquisição.",
          subItem:
            "Proposta não permite utilização de FGTS. Imóvel adquirido com utlização de FGTS há menos de 3 anos.",
          show: false,
        },
        {
          item:
            "Todos os nomes e CPFs dos vendedores estão averbados corretamente.",
          subItem:
            "Solicite consulta ao jurídico para prosseguir com a averbação concomitante dos dados não localizados.",
          show: false,
        },
      ],
      pendingFgtsList: [
        {
          item: "Autorização de FGTS no App.",
          subItem: "Solicitar autorização do cliente no app do FGTS.",
          notShow: false,
        },
        {
          item: "Extrato analítico.",
          subItem: "Solicitar extrato analítico a agência.",
          notShow: false,
        },
        {
          item: "Possui 36 meses de contribuição ao FGTS?",
          subItem:
            "Conferir se o cliente possuir no mínimo 36 meses de contribuição ao FGTS.",
          notShow: false,
        },
        {
          item: "Cliente não possui imóvel.",
          subItem: "Verifique se o cliente não possui imóvel.",
          notShow: false,
        },
        {
          item: "Declaração de IR com o respectivo recibo de entrega.",
          subItem:
            "Verifique se houve declaração de IR e recebimento do documento.",
          notShow: false,
        },
        {
          item:
            "Imóvel está situação no mesmo município de moradia/trabalho do cliente.",
          subItem:
            "Verifique se o imóvel objeto da operação pertence ao município que o cliente reside ou pretende trabalhar.",
          notShow: false,
        },
      ],
    };
  },
  components: {
    CurrencyInput,
    VueGoogleAutocomplete,
  },
  methods: {
    ...mapMutations(["setModificationNotification"]),
    ...mapActions(["getProposal"]),
    getAddressData(addressData, placeResultData) {
      const sublocalityArr = placeResultData.address_components.filter((el) =>
        el.types.includes("sublocality")
      );
      const administrative_area_level_2Arr = placeResultData.address_components.filter(
        (el) => el.types.includes("administrative_area_level_2")
      );
      const administrative_area_level_1Arr = placeResultData.address_components.filter(
        (el) => el.types.includes("administrative_area_level_1")
      );
      this.proposal.propertyLocation = {
        sublocality:
          sublocalityArr && sublocalityArr.length
            ? sublocalityArr[0].long_name
            : "",
        administrative_area_level_2:
          administrative_area_level_2Arr &&
          administrative_area_level_2Arr.length
            ? administrative_area_level_2Arr[0].long_name
            : "",
        administrative_area_level_1:
          administrative_area_level_1Arr &&
          administrative_area_level_1Arr.length
            ? administrative_area_level_1Arr[0].long_name
            : "",
        country: addressData.country ? addressData.country : "",
        latitude: addressData.latitude ? addressData.latitude : "",
        locality: addressData.locality ? addressData.locality : "",
        longitude: addressData.longitude ? addressData.longitude : "",
        postal_code: addressData.postal_code ? addressData.postal_code : "",
        route: addressData.route ? addressData.route : "",
      };
    },
  },
  computed: {
    ...mapState(["proposal", "user", "proposalToCheck"]),
    ...mapState("Notification", ["notifications"]),
    locationData: {
      get: function() {
        if (this.proposal.propertyLocation) {
          const location =
            this.proposal.propertyLocation.locality &&
            this.proposal.propertyLocation.route &&
            this.proposal.propertyLocation.sublocality
              ? `${this.proposal.propertyLocation.route} - ${this.proposal.propertyLocation.sublocality},${this.proposal.propertyLocation.locality}`
              : this.proposal.propertyLocation.route &&
                this.proposal.propertyLocation.sublocality
              ? `${this.proposal.propertyLocation.route} - ${this.proposal.propertyLocation.sublocality}`
              : this.proposal.propertyLocation.route
              ? `${this.proposal.propertyLocation.route}`
              : this.proposal.propertyLocation.locality
              ? `${this.proposal.propertyLocation.locality}`
              : `${this.proposal.propertyLocation.sublocality}`;
          if (
            this.proposal.propertyLocation.administrative_area_level_2 ===
            this.proposal.propertyLocation.administrative_area_level_1
          ) {
            return `${location},${this.proposal.propertyLocation.administrative_area_level_2} - State of ${this.proposal.propertyLocation.administrative_area_level_1}, ${this.proposal.propertyLocation.country}`;
          } else if (
            this.proposal.propertyLocation.administrative_area_level_2 ===
            this.proposal.propertyLocation.locality
          ) {
            return `${location},${this.proposal.propertyLocation.administrative_area_level_1}, ${this.proposal.propertyLocation.country}`;
          } else {
            return `${location},${this.proposal.propertyLocation.administrative_area_level_2}-${this.proposal.propertyLocation.administrative_area_level_1}, ${this.proposal.propertyLocation.country}`;
          }
        } else {
          return "";
        }
      },
      set: function(newValue) {
        if (this.propertyLocation.location) {
          const location = newValue.locality
            ? `${newValue.locality}, ${newValue.administrative_area_level_1}, ${newValue.country}`
            : newValue.route
            ? `${newValue.route},${newValue.administrative_area_level_1}, ${newValue.country}`
            : `${newValue.administrative_area_level_1}, ${newValue.country}`;
          return location;
        } else {
          return "";
        }
      },
    },
  },
  watch: {
    "proposal.steps.engineering.situation"(newVal, oldVal) {
      if (newVal === "Emitida") {
        this.proposal.steps.engineering.status = "";
      }
      if (oldVal || !this.proposal.steps.engineering.dueDate) {
        var today = new Date();
        var engineeringDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.engineering.dueDate = engineeringDate;
      }
      if (newVal) {
        for (let key in this.engineeringSituationOptions) {
          if (newVal === this.engineeringSituationOptions[key].value) {
            this.proposal.steps.engineering.color = this.engineeringSituationOptions[
              key
            ].color;
            this.proposal.steps.engineering.note = this.engineeringSituationOptions[
              key
            ].msg;
            this.proposal.steps.engineering[
              "progress"
            ] = this.engineeringSituationOptions[key].progress;
          }
        }
      } else {
        this.proposal.steps.engineering.color = "light";
        this.proposal.steps.engineering.note = "";
        this.proposal.steps.engineering.progress = 0;
      }
    },
    "proposal.steps.engineering.status"(newVal, oldVal) {
      if (newVal) {
        let situationArr = this.engineeringStatusOptions[
          this.proposal.steps.engineering.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.engineering.color = situation.color;
            if (situation.msg)
              this.proposal.steps.engineering.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.engineering.progress = situation.progress;
          }
        });
        if (
          this.proposal.steps.engineering.status == "Válido" &&
          this.proposal.engineeringEvaluation == 0
        ) {
          this.$bvToast.toast(
            `Informe o valor de avaliação da engenharia. ;)`,
            {
              title: "Eiiii... Lembrando!",
              variant: "primary",
              autoHideDelay: 2000,
            }
          );
          // this.$refs.engineeringEvaluation.$el.focus();
          if (oldVal || !this.proposal.steps.engineering.dueDate) {
            var today = new Date();
            var engineeringDate = moment(today).format("YYYY-MM-DD");
            this.proposal.steps.engineering.dueDate = engineeringDate;
          }
        }
        //  else {
        //   var today = new Date();
        //   var engineeringDate = moment(today).format("YYYY-MM-DD");
        //   this.proposal.steps.engineering.dueDate = engineeringDate;
        // }
      } else {
        for (let key in this.engineeringSituationOptions) {
          if (
            this.proposal.steps.engineering.situation ===
            this.engineeringSituationOptions[key].value
          ) {
            this.proposal.steps.engineering.color = this.engineeringSituationOptions[
              key
            ].color;
            this.proposal.steps.engineering.note = this.engineeringSituationOptions[
              key
            ].msg;
            this.proposal.steps.engineering.progress = this.engineeringSituationOptions[
              key
            ].progress;
          }
        }
      }
    },
    "proposal.steps.engineering.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.engineering["badgeColor"] = "light";
        this.proposal.steps.engineering["color"] = "light";
        this.proposal.steps.engineering["dueDate"] = "";
        this.proposal.steps.engineering["note"] = "";
        this.proposal.steps.engineering["situation"] = "";
        this.proposal.steps.engineering["status"] = "";
        this.proposal.steps.engineering["progress"] = 0;
      }
    },
    pendingList: {
      handler: function(val) {
        Vue.set(this.proposal, "pendingList", val);
      },
      deep: true,
    },
    bidderList: {
      handler: function(val) {
        Vue.set(this.proposal, "bidderList", val);
      },
      deep: true,
    },
    pendingFgtsList: {
      handler: function(val) {
        Vue.set(this.proposal, "pendingFgtsList", val);
      },
      deep: true,
    },
    proposal: {
      handler: function(val) {
        if (val.pendingList && val.pendingList.length) {
          this.pendingList = val.pendingList;
        } else if (
          !val.pendingList ||
          (val.pendingList && !val.pendingList.length)
        ) {
          Vue.set(this.proposal, "pendingList", this.pendingList);
        }
        if (val.pendingFgtsList && val.pendingFgtsList.length) {
          this.pendingFgtsList = val.pendingFgtsList;
        } else if (!val.pendingFgtsList) {
          Vue.set(this.proposal, "pendingFgtsList", this.pendingFgtsList);
        }
        if (this.proposal.participants && this.proposal.participants.length) {
          this.proposal.participants.forEach((element) => {
            if (!element.participantList) {
              element.participantList = JSON.parse(
                JSON.stringify(this.participantList)
              );
            }
          });
        }
        if (val.bidderList && val.bidderList.length) {
          this.bidderList = val.bidderList;
        } else if (!val.bidderList) {
          Vue.set(this.proposal, "bidderList", this.bidderList);
        }
      },
      immediate: true,
    },
  },
};
</script>
